import {PostConfirmRegistrationDataParams} from 'domain/usecases/private/home/post-confirm-registration-data';
import {makePostConfirmRegistrationData} from 'main/factories/usecases/private/remote-home/post-confirm-registration-data-factory';

export const postConfirmRegistrationData = async (params: PostConfirmRegistrationDataParams) => {
	const response = await makePostConfirmRegistrationData().post(params);
	return response;
};
